// Sends the contact form. The form is the only way to reach Blue Quanta, so it must never
// report success for a message that did not arrive: only a 2xx response counts as sent.
export const SEND_FAILED_MESSAGE = "Sorry, your message didn't go through. Please try again in a few minutes.";
export const NETWORK_FAILED_MESSAGE =
  "We couldn't reach our server. Please check your connection and try again.";

export async function submitContact({ name, email, text }, fetchImpl = globalThis.fetch) {
  let response;
  try {
    // Body is a JSON string with no content-type header: the API route parses the string itself.
    response = await fetchImpl("/api/sendEmail", {
      method: "POST",
      body: JSON.stringify({ email, name, text }),
    });
  } catch {
    return { ok: false, error: NETWORK_FAILED_MESSAGE };
  }
  if (response?.ok) return { ok: true };

  // Show the server's message only for a client error (4xx, e.g. "Please enter a valid email
  // address.") and only when it reads like a sentence for people. Server errors (5xx) and
  // machine codes such as "send_failed" always get the generic message.
  let message = null;
  if (response?.status >= 400 && response?.status < 500) {
    try {
      const body = await response.json();
      const candidate = typeof body?.error === "string" ? body.error.trim() : "";
      if (candidate.length <= 200 && /\s/.test(candidate) && /^[A-Z]/.test(candidate)) message = candidate;
    } catch {
      // not JSON; use the generic message
    }
  }
  return { ok: false, error: message || SEND_FAILED_MESSAGE };
}
